import Button from "components/button";
import LoaderButton from "components/button/LoaderButton";
import Modal from "components/modal";
import { useDispatch, useSelector } from "react-redux";
import { deleteAnnouncement } from "store/announcementSlice";

function DeleteAnnouncementModal({ announcement, isOpen, onClose, refreshList }) {
  const dispatch = useDispatch();
  const { deleteLoading, deleteError } = useSelector(
    (state) => state.announcements
  );

  const handleDelete = async () => {
    try {
      await dispatch(deleteAnnouncement({ _id: announcement._id })).unwrap();
      refreshList?.();
      onClose();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-lg">
      <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
        Delete Announcement
      </h2>

      <div className="relative w-full rounded-3xl p-4 lg:p-5">
        <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
          Are you sure you want to delete this announcement?
          {announcement?.message && (
            <span className="mt-2 block font-medium text-navy-700 dark:text-white">
              &quot;{announcement.message}&quot;
            </span>
          )}
        </p>

        <div className="flex flex-col">
          {deleteError && (
            <p className="mb-2 text-sm text-red-500">{deleteError}</p>
          )}

          <div className="mt-6 flex items-center justify-end gap-3">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <LoaderButton
              type="button"
              isLoading={deleteLoading}
              onClick={handleDelete}
            >
              Delete Announcement
            </LoaderButton>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteAnnouncementModal;
